import { render, staticRenderFns } from "./ZiliaoType.vue?vue&type=template&id=6a1a802f&scoped=true&"
import script from "./ZiliaoType.vue?vue&type=script&lang=js&"
export * from "./ZiliaoType.vue?vue&type=script&lang=js&"
import style0 from "./ZiliaoType.vue?vue&type=style&index=0&id=6a1a802f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a802f",
  null
  
)

export default component.exports